<div class="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gradient-to-r from-primary to-primary/80">
    <div class="flex items-center space-x-3">
      <div class="flex-shrink-0">
        <svg class="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
        </svg>
      </div>
      <div>
        <h2 class="text-xl font-bold text-white">What's New</h2>
        <p class="text-sm text-white/80">See what we've been working on</p>
      </div>
    </div>
    <button 
      (click)="close()"
      class="text-white/80 hover:text-white transition-colors">
      <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Content -->
  <div class="flex-1 overflow-y-auto px-6 py-4">
    <div *ngIf="isLoading" class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>

    <div *ngIf="!isLoading && releases.length === 0" class="text-center py-12">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p class="mt-2 text-gray-500">You're all caught up!</p>
    </div>

    <div *ngIf="!isLoading && releases.length > 0" class="space-y-8">
      <div *ngFor="let release of releases; let isFirst = first" class="relative">
        <!-- Version header -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center space-x-3">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-primary text-white">
              v{{ release.version }}
            </span>
            <span *ngIf="isFirst" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
              Latest
            </span>
          </div>
          <span class="text-sm text-gray-500">
            {{ formatDate(release.publishedAt) }}
          </span>
        </div>

        <!-- Release title -->
        <h3 *ngIf="release.title" class="text-lg font-semibold text-gray-900 mb-3">
          {{ release.title }}
        </h3>

        <!-- Changes list -->
        <ul class="space-y-3">
          <li *ngFor="let change of release.changes" class="flex items-start space-x-3">
            <span class="flex-shrink-0 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium" 
                  [ngClass]="getCategoryClass(change.category)">
              {{ getCategoryIcon(change.category) }} {{ getCategoryLabel(change.category) }}
            </span>
            <span class="text-gray-700">{{ change.text }}</span>
          </li>
        </ul>

        <!-- Separator -->
        <div *ngIf="!isFirst || releases.length > 1" class="mt-6 border-b border-gray-200"></div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end space-x-3">
    <button 
      (click)="close()"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
      Close
    </button>
    <button 
      (click)="acknowledge()"
      class="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md hover:bg-primary/90">
      Got it, thanks!
    </button>
  </div>
</div>
